import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './poker-ui/tailwind.css';
import './index.css';
import App from './App';

const googleClientId = (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();

const root = ReactDOM.createRoot(document.getElementById('root'));
const appTree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
root.render(
  googleClientId ? (
    <GoogleOAuthProvider clientId={googleClientId}>{appTree}</GoogleOAuthProvider>
  ) : (
    appTree
  )
);
